module.exports = __webpack_public_path__ + "static/img/4.4795ddf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer5/nav-1/4.jpg
// module id = SCFa
// module chunks = 0